/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    18/06/2018
 */
import { AbstractControl, FormGroup, ValidatorFn } from '@angular/forms';

export class ValidatorFactory {
    public static equal(key: string, validateOther: boolean): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } | null => {
            const object = control.root.get(key);

            if (!object) {
                return null;
            }

            if (validateOther) {
                object.updateValueAndValidity({
                    onlySelf: true,
                    emitEvent: false,
                });
                return null;
            } else {
                return object.value === control.value ? null : { equal: { valid: false } };
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/shared/module/validation/validator-factory.ts